import digitalData from 'digital-data';
import { setAnalytics } from '../../../thd-analytics-utils';

const PRIMARY_CATEGORY = 'magic cart';

export function magicApronStore() {
  // MCA 1.1 Magic Cart Page Load Tracking (Home / Product Details / Store Map)
  window.LIFE_CYCLE_EVENT_BUS.lifeCycle.on('magic-apron-store.page-load', ({ output = {} }) => {
    const { sessionID = '', page = 'mac:home', productName = '', productType = '', productOmsId = '', productSku = '' } = output;
    digitalData.page = {
      category: {
        primaryCategory: PRIMARY_CATEGORY,
        subCategory1: PRIMARY_CATEGORY,
        subCategory2: PRIMARY_CATEGORY
      },
      pageInfo: {
        pageName: page,
        pageTemplate: 'default',
        pageType: PRIMARY_CATEGORY
      },
      maSessionID: sessionID
    };
    if (productOmsId) {
      digitalData.product = [{
        productInfo: {
          sku: productOmsId,
          productName,
          productType
        },
        storeProductInfo: {
          sku: productSku
        }
      }];
    } else {
      digitalData.product = [];
    }
    setAnalytics(digitalData);
  });
}
